/** HTTP 409 from the factsheet optimistic lock. */
export function isConflictError(err: { status?: number } | null | undefined): boolean {
  return err?.status === 409;
}

export const CONFLICT_RELOAD_MESSAGE = 'Document was changed elsewhere — Reload';
